import React from "react";
import { CheckmarkRegular, SubtractRegular } from "@fluentui/react-icons";
import {
  AVATAR_COLORS,
  getColorIndex,
  circularCheckboxBaseClass,
  circularCheckboxCheckedClass,
  circularCheckboxIndeterminateClass,
  circularCheckboxUncheckedClass,
  circularCheckboxSelectAllUncheckedClass,
} from "./styles";

type Props = {
  name: string;
  checked: boolean;
  indeterminate?: boolean;
  onChange: () => void;
};

const CircularCheckbox = React.forwardRef<HTMLButtonElement, Props & React.ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ name, checked, indeterminate = false, onChange, ...rest }, ref) => {
    const isSelectAll = name === "";

    let stateClass: string;
    if (checked) {
      stateClass = circularCheckboxCheckedClass;
    } else if (indeterminate) {
      stateClass = circularCheckboxIndeterminateClass;
    } else if (isSelectAll) {
      stateClass = circularCheckboxSelectAllUncheckedClass;
    } else {
      stateClass = circularCheckboxUncheckedClass(AVATAR_COLORS[getColorIndex(name)]);
    }

    let content: React.ReactNode;
    if (checked) {
      content = <CheckmarkRegular style={{ fontSize: 14 }} />;
    } else if (indeterminate) {
      content = <SubtractRegular style={{ fontSize: 14 }} />;
    } else {
      content = name ? name[0].toUpperCase() : null;
    }

    return (
      <button
        {...rest}
        ref={ref}
        type="button"
        role="checkbox"
        aria-checked={indeterminate ? "mixed" : checked ? "true" : "false"}
        aria-label={isSelectAll ? "Select all" : name}
        className={`${circularCheckboxBaseClass} ${stateClass}`}
        onClick={(e) => {
          e.stopPropagation();
          onChange();
        }}
      >
        {content}
      </button>
    );
  }
);

export default CircularCheckbox;
